export type CalendarForecastRequirement =
  | {
      productId: string;
      showForecastOnHover: true;
      blockDatesWithoutInventory?: boolean;
    }
  | {
      productId: string;
      showForecastOnHover?: false;
      blockDatesWithoutInventory: true;
    }
  | {
      productId?: string;
      showForecastOnHover?: false;
      blockDatesWithoutInventory?: false;
    };

export function buildCalendarForecastRequirement({
  productId,
  blockDatesWithoutInventory,
  showForecastOnHover = false,
}: {
  productId?: string;
  blockDatesWithoutInventory: boolean;
  showForecastOnHover?: boolean;
}): CalendarForecastRequirement {
  if (productId && showForecastOnHover) {
    return {
      productId,
      showForecastOnHover: true,
      blockDatesWithoutInventory,
    };
  }
  if (productId && blockDatesWithoutInventory) {
    return {
      productId,
      showForecastOnHover: false,
      blockDatesWithoutInventory: true,
    };
  }
  return {
    productId,
    showForecastOnHover: false,
    blockDatesWithoutInventory: false,
  };
}

export interface ProductForecast {
  count: number;
  drops: number;
  picks: number;
  initialCount: number;
}

export interface Product {
  id: string;
  shortCode?: string;
  cubicYardage?: string | number;
}

export type ForecastDictionary = Record<
  string,
  Record<string, ProductForecast>
>;

export interface ForecastData {
  forecast: ForecastDictionary;
  products?: Product[];
}

export interface EmptyForecast {
  forecast: Record<string, never>;
}

export type Forecast = ForecastData | EmptyForecast;

export interface DateInfo {
  dateStr: string;
  specialDate?: { date: string; reason?: string | null };
  businessHour?: {
    dayOfWeek: number;
    status: string;
    openTime: string | null;
    closeTime: string | null;
  };
  isPastDay: boolean;
  isToday: boolean;
  hasInventory: boolean;
  forecastForDate?: Record<string, ProductForecast>;
  productForecast?: ProductForecast;
}

export interface DateInfoQuery extends DateInfo {
  isClosed: boolean;
  isUnavailable: boolean;
  isInRange: boolean;
  isOverLimit: boolean;
  isFirstInRange: boolean;
  isLastInRange: boolean;
}
